import {Component, OnInit} from '@angular/core';
import { TeamService } from '@core/services/team.service';
import { AppTeam } from '@shared/models/team';
import {PageOfTeam, PageOfTeamType} from '@shared/models/page-of-team';

@Component({
  selector: 'team-info-contact',
  templateUrl: './team-info-contact.component.html',
  styleUrls: ['./team-info-contact.component.scss'],
})


export class TeamInfoContactComponent implements OnInit {

  team: AppTeam;

  teamContact: PageOfTeam[];
  hasContact = false;
  hasLinks = false;

  socialMediaElements: PageOfTeam[] = [];

  private readonly orderOfSocialMediaElements = [
    PageOfTeamType.FACEBOOK,
    PageOfTeamType.INSTA,
    PageOfTeamType.YOUTUBE,
    PageOfTeamType.TWITTER,
    PageOfTeamType.HOMEPAGE
  ];

  constructor( private teamService: TeamService ) { }

  ngOnInit() {
    this.team = this.teamService.getCurrentTeam();
    this.teamContact = this.team.pages;

    this.teamContact.forEach(page => {
      if (!this.hasContact && page.isContactInfo() && page.url) {
        this.hasContact = true;
      }
      if (page.isSocialPage() && page.url) {
        this.socialMediaElements.push(page);
        this.hasLinks = true;
      }
    });

    this.socialMediaElements = this.socialMediaElements.sort((a, b) => {
      const orderIndexOfA = this.orderOfSocialMediaElements.findIndex(value => value === a.type);
      const orderIndexOfB = this.orderOfSocialMediaElements.findIndex(value => value === b.type);
      if (orderIndexOfA < orderIndexOfB) {
        return -1;
      } else if (orderIndexOfA > orderIndexOfB) {
        return 1;
      }
      return 0;
    });
  }
}
